export class QuoteStatus {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
}
